import {save} from "@api/admin.js";
import { showProductAttr,updateProductDesc,saveProductSaleAttr } from "@api/store.js";
export default {
    data(){
        return {
            serviceUrl: "/eb/store/product",  //每个页面访问后台服务器的路径
            currentIdFiledName: 'id',
            paasFormData: {
                id: '',
                fkaStoreCategoryId: '',
                fkaStoreCategoryName: '',
                otPrice: '',
                isBest: '',
                isBargain: '',
                soureLink: '',
                ficti: '',
                giveIntegral: '',
                unitName: '',
                isDel: '',
                sales: '',
                sliderImage: '',
                posterImage:"",
                isPostage: '',
                merId: '',
                keyword: '',
                addTime: '',
                isShow: '',
                stock: '',
                cost: '',
                isHot: '',
                description: '',
                storeName: '',
                isBenefit: '',
                storeInfo: '',
                isSeckill: '',
                vipPrice: '',
                price: '',
                isNew: '',
                browse: '',
                codePath: '',
                sort: '',
                merUse: '',
                image: '',
                postage: '',
                brand: '',
                goodWight: '',
                productSeason: '',
                productYear: '',
                paasRepeatSubmitFlag: '',
                sliderFilesJson: '',
                imageFileJson: '',
                productNo:'',
            },
            paasFormRules: {
                productNo:[
                    { required: true, message: '货号不能为空', trigger: 'blur' }
                ],
                brand:[
                    {required: true, message: '品牌不能为空', trigger: 'change'}
                ]
            },
            /**
             * 下拉树
             * */
            showfkaStoreCategoryNameTree: false,
            redirectName: "storeProductList",
            nextAddName: "storeProductEdit",
            showAttr: false,
            currentIndex: -1,
            saleMap: {},
            saleForm: [],//checkbox选中的值，首次进来需要渲染
            tableItems: [],  //表格数据
            thsort: [],
            myConfig: {
                autoHeightEnabled: false,// 编辑器不自动被内容撑高,默认true
                initialFrameHeight: "800",//初始化编辑器高度,默认320
                initialFrameWidth: '100%',
                //initialFrameWidth: '350',  //初始化编辑器宽度,默认1000
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                UEDITOR_HOME_URL: '/UE/',
                initialContent: '请输入内容',
                autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
                // 工具栏是否可以浮动
                autoFloatEnabled: false,
                // serverUrl: "http://jx.yuetrip.cn:88/ueditor/ueditorConfig"
                serverUrl: "https://wx.api.gymthy.com/ueditor/ueditorConfig"
            },
            saleObj: {},
            imageFile: '',
            uploadPath: this.$store.state.sysApi + "/sys/file/uploadAttacheSlice",
            sliderImages: [],
            colorObj: {
                code: '',
                color: '',
                desc: '',
                name: '',
                type: 'color'
            },
            otherObj: {
                code: '',
                desc: '',
                name: '',
                type: ''
            },
            justifyAddOrDelete:"",
        }
    },
    methods:{

        /**
         * table里边input改变颜色名
         * @param val
         * @param name
         */
        changeTableItemColor(val,name){
            if(this.tableItems != null && this.tableItems.length > 0){
                for(let i = 0; i < this.tableItems.length; i++){
                    if(this.tableItems[i].color.color === val){
                        this.tableItems[i].color.name = name;
                    }
                }
            }

            if(this.saleObj.color !== null && this.saleObj.color.length > 0){
                for(let i = 0; i < this.saleObj.color.length; i++){
                    if(this.saleObj.color[i].color.value === val){
                        this.saleObj.color[i].desc.value = name;
                        break;
                    }
                }
            }
            ;
        },
        /**
         * 计算table合并行数
         */
        calRowSpan(type){
            let mergeRow = 1;
            for(let key in this.saleObj){
                if(key !== type && this.saleObj[key].length > 0){
                    mergeRow *= this.saleObj[key].length;
                }
            }
            return mergeRow;
        },
        /**
         * 计算库存量
         * */
        calcuTotalStock(){
            let totalStock = 0;
            if(this.tableItems != null && this.tableItems.length > 0){
                for(let i = 0; i < this.tableItems.length; i++){
                    if(this.tableItems[i].stock && this.tableItems[i].stock !== 0){
                        totalStock += Number(this.tableItems[i].stock);
                    }
                }
            }
            this.paasFormData.stock = totalStock;
        },
        /**
         * 获取文档内容
         */
        paasFormSubmitDesc(){
            let param = {
                desc:this.paasFormData.description,
                id:this.paasFormData.id,
            };
            updateProductDesc(param).then(res => {
                if(res.code === 200){
                    this.$Message.success("商品详情数据保存成功")
                }
            }).catch((err)=>{
                this.$Message.error("商品详情数据保存失败");
            })
        },
        /**
         * 保存销售属性
         * */
        paasFormSubmitAttr(){
            let param = {
                productId:this.paasFormData.id,
                attrs:JSON.stringify(this.saleObj),
                saleAttrs:JSON.stringify(this.tableItems),
                stock:this.paasFormData.stock,
                attrValues:JSON.stringify(this.saleForm),
                colorFiles:JSON.stringify(this.colorFiles)
            };
            saveProductSaleAttr(param).then(res => {
                if(res.code === 200){
                    this.$Message.success("销售属性数据保存成功")
                }
            }).catch((err)=>{
                this.$Message.error("销售属性数据保存失败");
            })


        },
        /**
         * 显示节点下拉树
         */
        changefkaStoreCategoryNameFlag(){
            let selectCategoryId = this.paasFormData.fkaStoreCategoryId;
            //遍历tree,改checked为false
            for(let j = 0; j < selectCategoryId.split(",").length; j++){
                this.$refs.categoryTree.setTreeCheckedStatu(selectCategoryId.split(",")[j],true);
            }
            this.showfkaStoreCategoryNameTree = true;
        },
        /**
         * 多选
         * */
        updatefkaStoreCategoryNameTreeNode(node){
            let selectCategoryIdArr = this.paasFormData.fkaStoreCategoryId.split(",");
            let selectCategoryNameArr = this.paasFormData.fkaStoreCategoryName.split(",");
            let resultId = "";
            let resultName = "";
            if(node.checked){
                if(this.paasFormData.fkaStoreCategoryId){
                    if(this.paasFormData.fkaStoreCategoryId.indexOf(node.id) === -1){
                        //判断是否含有当前id
                        this.paasFormData.fkaStoreCategoryName += ","+node.title;
                        this.paasFormData.fkaStoreCategoryId += ","+node.id;
                        this.$refs.categoryTree.setTreeCheckedStatu(node.id,true);
                    }else{
                        for(let i = 0 ; i < selectCategoryIdArr.length;i++){
                            if(selectCategoryIdArr[i] !== node.id){
                                if(resultId){
                                    resultId += ",";
                                    resultName += ","
                                }
                                resultId += selectCategoryIdArr[i];
                                resultName += selectCategoryNameArr[i];
                            }
                        }
                        this.paasFormData.fkaStoreCategoryId = resultId;
                        this.paasFormData.fkaStoreCategoryName = resultName;
                        this.$refs.categoryTree.setTreeCheckedStatu(node.id,false);
                    }
                }else{
                    this.paasFormData.fkaStoreCategoryName = node.title;
                    this.paasFormData.fkaStoreCategoryId = node.id;
                    this.$refs.categoryTree.setTreeCheckedStatu(node.id,true);
                }

            }else{
                if(this.paasFormData.fkaStoreCategoryId.indexOf(node.id) !== -1){
                    for(let i = 0 ; i < selectCategoryIdArr.length;i++){
                        if(selectCategoryIdArr[i] !== node.id){
                            if(resultId){
                                resultId += ",";
                                resultName += ","
                            }
                            resultId += selectCategoryIdArr[i];
                            resultName += selectCategoryNameArr[i];
                        }
                    }
                    this.paasFormData.fkaStoreCategoryId = resultId;
                    this.paasFormData.fkaStoreCategoryName = resultName;
                }
                this.$refs.categoryTree.setTreeCheckedStatu(node.id,false);
            }

            this.showfkaStoreCategoryNameTree = false;
        },
        handlefkaStoreCategoryNameClose(){
            this.showfkaStoreCategoryNameTree = false;
        },
        /**
         * 清除后查询
         */
        clearfkaStoreCategoryName(){
            //遍历tree,改checked为false
            let selectCategoryId = this.paasFormData.fkaStoreCategoryId;
            //遍历tree,改checked为false
            for(let j = 0; j < selectCategoryId.split(",").length; j++){
                this.$refs.categoryTree.setTreeCheckedStatu(selectCategoryId.split(",")[j],false);
            }
            this.paasFormData.fkaStoreCategoryId = "";

        },

        paasFormSubmit(){
            let sliderImage = "";
            let mainImage = "";
            let videoUrl = "";
            if(this.sliderFiles != null && this.sliderFiles.length > 0){
                for(let i = 0; i < this.sliderFiles.length; i++){
                    sliderImage += this.sliderFiles[i].originalUrl;
                    if(i === 0){
                        mainImage = sliderImage;
                    }
                    if(i !== this.sliderFiles.length-1){
                        sliderImage += ",";
                    }
                }
            }
            if(this.fileList !== null && this.fileList.length > 0){
                videoUrl = this.fileList[0].originalUrl;
            }
            this.paasFormData.sliderImage = sliderImage;
            this.paasFormData.mainImage = mainImage;  //产品主图
            this.paasFormData.videoUrl = videoUrl;
            this.paasFormData.sliderFilesJson = JSON.stringify(this.sliderFiles);  //产品轮播图数据
            save(this.serviceUrl,this.paasFormData).then(res => {
                if(res.code === 200){
                    this.paasFormData.id = res.data.entity.id;
                    this.paasFormData.paasRepeatSubmitFlag = res.data.paasRepeatSubmitFlag;
                    this.$Message.success('数据保存成功！');
                }
            }).catch(err =>{
                this.$Message.error('数据查询失败，请重试！');
            });
        },
        /**
         * 是否显示该标签,点击tab按键切换
         * @param val
         */
       async justifyShow(val){
            //所有附件模态框关闭
            //this.uploadModal = false;
            this.multiUploadModal = false;
            this.colorModal = false;
            if(this.paasFormData.id && (val === 1 || val === 2)){
                this.showAttr = true;
                let {code,data} = await showProductAttr(this.paasFormData.id);
                if(code === 200){
                    this.saleMap = data.saleMap;
                    console.log( this.saleMap)
                    let newSort = [];
                    for(let key in  this.saleMap){
                        newSort.push(key);
                    }
                    this.thsort = newSort;
                    this.saleForm = data.attrs;
                    this.saleObj = data.saleObjMap;
                    this.tableItems = data.saleList;
                    this.saleCheck = data.saleCheck; //全选
                }
              else(err =>{
                    this.$Message.error('数据查询失败，请重试！');
                });
            }
        },
        /**
         * 数组自由组合
         * @param arr
         * @returns {*}
         */
        permutationArray(arr){
            let len = arr.length;
            // 当数组大于等于2个的时候
            if(len >= 2){
                // 第一个数组的长度
                let len1 = arr[0].length;
                // 第二个数组的长度
                let len2 = arr[1].length;
                // 2个数组产生的组合数
                let lenBoth = len1 * len2;
                //  申明一个新数组,做数据暂存
                let items = new Array(lenBoth);
                // 申明新数组的索引
                let index = 0;
                // 2层嵌套循环,将组合放到新数组中
                for(let i=0; i<len1; i++){
                    for(let j=0; j<len2; j++){
                        let itemMap = {};
                        itemMap[arr[0][i].type] = arr[0][i];
                        itemMap[arr[1][j].type] = arr[1][j];
                        items[index] = itemMap;
                        index++;
                    }
                }
                // 将新组合的数组并到原数组中
                let newArr = new Array(len -1);
                for(let i=2;i<arr.length;i++){
                    newArr[i-1] = arr[i];
                }
                newArr[0] = items;
                // 执行回调
                return this.permutationArray(newArr);
            }else{
                if(arr[0][0].type && typeof(arr[0][0].type) != 'undefined'){
                    let items = new Array(arr[0].length);
                    // 申明新数组的索引
                    let index = 0;
                    for(let i=0; i<arr[0].length; i++){
                        let itemMap = {};
                        itemMap[arr[0][i].type] = arr[0][i];
                        items[index] = itemMap;
                        index++;
                    }
                    return items;
                }else{
                    return arr[0];
                }

            }
        },
        convertNeedFieldData(fieldData,key){
            let arr = {
                name:fieldData.name.value,
                code:fieldData.code.value,
                desc:fieldData.desc.value,
                type:key,
            };
            if(key === 'color'){
                arr.color = fieldData.color.value;
            }
            return arr;
        },
        convertNeedList(fieldData,key){
            let arrList = [];
            if(fieldData != null && fieldData.length > 0){
                for(let i =0; i < fieldData.length;i++){
                    arrList.push(this.convertNeedFieldData(fieldData[i],key));
                }
            }
            return arrList;
        },
        convertTableItemColorProp(keyArr,val,key){
            let propItem = {};
            for(let j =0 ; j < keyArr.length; j++){
                if(key === "color"){
                    if(val === keyArr[j].fieldDataPropMap.color.value){
                        propItem = this.convertNeedFieldData(keyArr[j].fieldDataPropMap,key);
                        break;
                    }
                }else{
                    if(val === keyArr[j].fieldDataPropMap.name.value){
                        propItem = this.convertNeedFieldData(keyArr[j].fieldDataPropMap,key);
                        break;
                    }
                }

            }
            return propItem;
        },
        //比较
        compactReturnProp(fieldItem,field){
            let currentFieldPropMap = {};
            for(let j = 0; j < this.saleMap[field].length;j++){
                if(field === "color"){
                    if(fieldItem === this.saleMap[field][j].fieldDataPropMap.color.value){
                        currentFieldPropMap = this.saleMap[field][j].fieldDataPropMap;
                        break;
                    }
                }else{
                    if(fieldItem === this.saleMap[field][j].fieldDataPropMap.name.value){
                        currentFieldPropMap = this.saleMap[field][j].fieldDataPropMap;
                        break;
                    }
                }
            }
            return currentFieldPropMap;
        },
        /**
         * 要删除的数据
         * @param val
         * @param key
         */
        convertDeleteSaleData(val,key){
            let newTableList = [];

            if(this.tableItems != null && this.tableItems.length > 0){
                for(let i = 0; i < this.tableItems.length; i++){
                    let tItem = this.tableItems[i];
                    if(key === "color"){
                        if(tItem[key].color !== val){
                            newTableList.push(tItem);
                        }
                    }else{
                        if(tItem[key].name !== val){
                            newTableList.push(tItem);
                        }
                    }
                }
            }

            //某种属性没选任何选项的时候，需要重组
            newTableList = this.insertChangeTableDat(newTableList);

            return newTableList;
        },
        /**
         * 选中后要加入的数据，插入位置怎么算呢？
         * @param val
         * @param key
         * @returns {Array}
         */
        convertAddSaleData(val,key){
            let newCreateParam = [];
            newCreateParam.push(val);
            let tableList = this.packNewTableDat(key,newCreateParam);
            let newTableList = this.insertChangeTableDat(tableList);

            return newTableList;
        },

        /**
         * 点击CheckBox判断是否选中,删除或者添加一条数据
         * @param val
         */
        clickSingleCheckbox(val,key){
            let checkedArr = this.saleForm[key];
            let flag = "";
            if(checkedArr && typeof(checkedArr) !== "undefined"){
                if(checkedArr.indexOf(val) !== -1){
                    flag = "delete";
                }else{
                    flag = "add";
                }
            }else{
                flag = "add";
            }

            this.justifyAddOrDelete = {
                flag:flag,
                parameter:val,
                type:key
            };
        },
        /**
         * 新增的数据插入到table正确位置
         * @param tableList
         */
        insertChangeTableDat(tableList){
            let newTableList = [];
            //插入到哪个位置
            /**
             * collectArray的数据
             * 0: Array(2)
             0: {name: "蓝色", code: " blue", desc: "蓝色", type: "color", color: "#1D35EA"}
             1: {name: "黑色", code: " black", desc: "黑色", type: "color", color: "#000000"}
             1: Array(1)
             0: {name: "XL", code: "XL", desc: "", type: "sizeClothing"}
             * @type {Array}
             */
            let collectArray = [];
            for(let saleKey in  this.saleObj){
                let needList = this.convertNeedList(this.saleObj[saleKey],saleKey);
                if(needList.length === 0){
                    if(saleKey === "color"){
                        needList.push(this.colorObj);
                    }else{
                        this.otherObj.type = saleKey;
                        needList.push(this.otherObj);
                    }
                }
                collectArray.push(needList);
            }
            if(collectArray.length > 0) {
                /**
                 * 数据排列组合
                 * 0:
                 color: {name: "蓝色", code: " blue", desc: "蓝色", type: "color", color: "#1D35EA"}
                 sizeClothing: {name: "XL", code: "XL", desc: "", type: "sizeClothing"}
                 1:
                 color: {name: "黑色", code: " black", desc: "黑色", type: "color", color: "#000000"}
                 sizeClothing: {name: "XL", code: "XL", desc: "", type: "sizeClothing"}
                 */
                let permutaArray = this.permutationArray(collectArray);
                for(let i = 0; i < permutaArray.length; i++){
                    let permutaItem = permutaArray[i];
                    let flag = "yes"; //判断是否匹配
                    for(let m = 0; m <  this.tableItems.length; m++){
                        let tItem = this.tableItems[m];
                        for(let item in this.saleForm){
                            flag = "yes";
                            if(item === "color"){
                                if((!tItem[item].name && tItem[item].color == null )|| permutaItem[item].color !== tItem[item].color){
                                    flag = "no";
                                    break;
                                }
                            }else{
                                if((!tItem[item].name && tItem[item].color == null ) || permutaItem[item].name !== tItem[item].name){
                                    flag = "no";
                                    break;
                                }
                            }
                        }
                        if(flag === "yes"){
                            newTableList.push(tItem);
                            break;
                        }
                    }

                    if(flag !== "yes"){
                        if(tableList.length > 0){
                            for(let n = 0; n < tableList.length; n++){
                                for(let item in this.saleForm){
                                    flag = "yes";
                                    if(item === "color"){
                                        if(permutaItem[item].color !== tableList[n][item].color){
                                            flag = "no";
                                            break;
                                        }
                                    }else{
                                        if(permutaItem[item].name !== tableList[n][item].name){
                                            flag = "no";
                                            break;
                                        }
                                    }
                                }
                                if(flag === "yes"){
                                    newTableList.push(tableList[n]);
                                    break;
                                }

                            }
                        }else{
                            let tableItem = {};
                            tableItem.productId = this.paasFormData.id;
                            tableItem.suk = "";
                            tableItem.barCode = "";
                            tableItem.internalCode = "";
                            tableItem.price = 0;
                            tableItem.cost = 0;
                            tableItem.stock = 0;
                            tableItem.colorImg = "";
                            tableItem.deleteUrl = "";
                            tableItem.viewImg = "";
                            for(let key in permutaItem){
                                tableItem[key] = permutaItem[key];
                            }
                            newTableList.push(tableItem);
                        }

                    }
                }
            }
            return newTableList;
        },

        /**
         * 取消全选的逻辑，重新组装table数据
         * @param key
         */
        cancelAll(key){
            let collectArray = [];
            for(let key in  this.saleObj){
                if(this.convertNeedList(this.saleObj[key],key).length > 0){
                    collectArray.push(this.convertNeedList(this.saleObj[key],key));
                }
            }

            let checkArray = [];
            if(collectArray.length > 0){
                let permutaArray = this.permutationArray(collectArray);
                if(permutaArray != null && permutaArray.length > 0){
                    for(let i = 0 ;i < permutaArray.length; i++){
                        let arr = {};
                        for(let key in permutaArray[i]){
                            arr[key] = permutaArray[i][key];
                        }
                        arr.productId = this.paasFormData.id;
                        arr.suk = "";
                        arr.barCode = "";
                        arr.internalCode = "";
                        arr.price = 0;
                        arr.cost = 0;
                        arr.stock = 0;
                        arr.colorImg = "";
                        arr.deleteUrl = "";
                        arr.viewImg = "";
                        this.emptyFieldProp(arr);
                        checkArray.push(arr);
                    }
                }
            }
            return checkArray;
        },
        /**
         * 全选的逻辑
         */
        checkAll(key,newCreateParam){
            let newTableList = [];
            let tableList = this.packNewTableDat(key,newCreateParam);
            newTableList = this.insertChangeTableDat(tableList);
            return newTableList;
        },
        /**
         * 选中数据发生改变时，触发的方法
         */
        changeCheckedKey(){
            let newTableList = [];
            //组装
            this.convertSaleObj(this.justifyAddOrDelete.type);
            //如果是添加，在原有的data添加一条数据
            if(this.justifyAddOrDelete.flag === "add"){
                newTableList = this.convertAddSaleData(this.justifyAddOrDelete.parameter,this.justifyAddOrDelete.type);
            }else if(this.justifyAddOrDelete.flag === "delete"){
                newTableList = this.convertDeleteSaleData(this.justifyAddOrDelete.parameter,this.justifyAddOrDelete.type);
            }else if(this.justifyAddOrDelete.flag === "checkAll"){
                newTableList = this.checkAll();
            }else if(this.justifyAddOrDelete.flag === "cancelAll"){

            }else{

            }
            this.tableItems = newTableList;
            /**
             * 计算库存
             */
            this.calcuTotalStock();
        },
        /**
         * 判断除了当前选中的属性是否还有其他属性被选中，true为有其他被选中了，FALSE只选中当前项
         * @param key
         * @returns {boolean}
         */
        justifySaleFormSelect(key){
            let selectMultFlag = false;
            if(this.saleForm != null && key in this.saleForm){
                for(let item in this.saleForm){
                    if(item !== key){
                        if(this.saleForm[item].length > 0){
                            selectMultFlag = true;
                            break;
                        }
                    }
                }
            }
            return selectMultFlag;
        },
        /**
         * 点击全选
         * @param key
         */
        handleCheckAll(key){
            let newTableList = [];
            if(this.saleCheck[key].indeterminate){
                this.saleCheck[key].checkAll = false;
            }else {
                this.saleCheck[key].checkAll = !this.saleCheck[key].checkAll;
            }
            this.saleCheck[key].indeterminate = false;
            let checkFlag = "";
            let parameter = [];
            if (this.saleCheck[key].checkAll) {
                for(let i = 0; i < this.saleCheck[key].checkAllValue.length; i++){
                    let existFlag = "no";
                    if(key in this.saleForm && this.saleForm[key].length > 0){
                        for(let j = 0; j < this.saleForm[key].length; j++){
                            if(this.saleCheck[key].checkAllValue[i] === this.saleForm[key][j]){
                                existFlag = "yes";
                                break;
                            }
                        }
                    }
                    if(existFlag === "no"){
                        parameter.push(this.saleCheck[key].checkAllValue[i]);
                    }
                }
                this.saleForm[key] = this.saleCheck[key].checkAllValue;
                checkFlag = "checkAll";

            } else {
                this.saleForm[key] = [];
                checkFlag = "cancelAll";
            }
            this.convertSaleObj(key);
            if(checkFlag === "checkAll"){
                //全选如何渲染table
                checkFlag = "checkAll";
                newTableList = this.checkAll(key,parameter);
            }else{
                newTableList = this.cancelAll(key);
            }
            this.tableItems = newTableList;
        },
        /**
         * 如果有n种属性，但是只有一个属性有选择值的，需要把其他属性置空,一般在对象全部组装赋值后再赋值
         * @param tableItem
         */
        emptyFieldProp(tableItem){
            for(let attrKey in this.saleMap){
                //判断该对象是否存在某个属性值
                if(!(attrKey in tableItem)){
                    if(attrKey === 'color'){
                        tableItem[attrKey] = this.colorObj;
                    }else{
                        tableItem[attrKey] = this.otherObj;
                    }
                }
            }
        },
        traverseQueryImageUrl(colorVal){
            let urlObj = {
                colorImg:"",
                viewImg:"",
                deleteUrl:""
            };
            if(this.tableItems != null && this.tableItems.length > 0){
                for(let i = 0; i < this.tableItems.length; i++){
                    if(this.tableItems[i].color.color === colorVal){
                        urlObj.colorImg = this.tableItems[i].colorImg;
                        urlObj.viewImg = this.tableItems[i].viewImg;
                        urlObj.deleteUrl = this.tableItems[i].deleteUrl;
                        break;
                    }
                }
            }
            return urlObj;
        },
        /**
         * 组装添加的属性数据
         * @param key
         * @param parameters
         * @returns {Array}
         */
        packNewTableDat(key,parameters){
            let tableList = [];
            //判断除了当前项是否还有其他属性选中
            let selectMultiFlag = this.justifySaleFormSelect(key);
            //有其他选项
            if(selectMultiFlag){
                for(let field in this.saleForm){
                    if(key !== field){
                        let fieldArr = this.saleForm[field];
                        for(let i =0 ; i < fieldArr.length; i++){
                            let currentFieldPropMap = this.compactReturnProp(fieldArr[i],field);
                            let fieldMap = this.convertNeedFieldData(currentFieldPropMap,field);
                            for(let j = 0; j < parameters.length;j++){
                                let tableItem = {};
                                tableItem[field] = fieldMap;
                                let keyArr = this.saleMap[key];
                                tableItem[key] = this.convertTableItemColorProp(keyArr,parameters[j],key);
                                tableItem.productId = this.paasFormData.id;
                                tableItem.suk = "";
                                tableItem.barCode = "";
                                tableItem.internalCode = "";
                                tableItem.price = 0;
                                tableItem.cost = 0;
                                tableItem.stock = 0;
                                let colorImg = "";
                                let deleteUrl = "";
                                let viewImg = "";
                                //如果添加的是非颜色属性，看看颜色图片，顺便赋值
                                if(key !== "color" && field === "color"){
                                    let urlObj = this.traverseQueryImageUrl(fieldArr[i]);
                                    colorImg = urlObj.colorImg;
                                    deleteUrl = urlObj.deleteUrl;
                                    viewImg = urlObj.viewImg;
                                }
                                tableItem.colorImg = colorImg;
                                tableItem.deleteUrl= deleteUrl;
                                tableItem.viewImg = viewImg;
                                this.emptyFieldProp(tableItem);
                                tableList.push(tableItem);
                            }
                        }
                    }
                }
            }else{
                for(let j = 0; j < parameters.length;j++){
                    let tableItem = {};
                    let keyArr = this.saleMap[key];
                    tableItem[key] = this.convertTableItemColorProp(keyArr,parameters[j],key);
                    tableItem.productId = this.paasFormData.id;
                    tableItem.suk = "";
                    tableItem.barCode = "";
                    tableItem.internalCode = "";
                    tableItem.price = 0;
                    tableItem.cost = 0;
                    tableItem.stock = 0;
                    tableItem.colorImg = "";
                    tableItem.deleteUrl = "";
                    tableItem.viewImg = "";
                    this.emptyFieldProp(tableItem);
                    tableList.push(tableItem);
                }
            }

            return tableList;
        },
        /**
         * 每次属性值选中发生改变都需要转化一下
         * @param key
         */
        convertSaleObj(key){
            let saleObj = {};
            let selectFlag = this.justifySaleFormSelect(key);

            if(selectFlag){
                if(this.saleMap != null){
                    for(let field in this.saleMap){
                        for(let form in this.saleForm){
                            if(field === form){
                                let fieldArr = this.saleMap[field];
                                let formArr = this.saleForm[field];
                                let saleArr = [];
                                if(fieldArr != null && fieldArr.length > 0){
                                    for(let i = 0; i < fieldArr.length;i++){
                                        if(formArr != null && formArr.length > 0){
                                            for(let j = 0; j < formArr.length;j++){
                                                if(field === "color"){
                                                    if(formArr[j] === fieldArr[i].fieldDataPropMap.color.value){
                                                        saleArr.push(fieldArr[i].fieldDataPropMap);
                                                        break;
                                                    }
                                                }else{
                                                    if(formArr[j] === fieldArr[i].fieldDataPropMap.name.value){
                                                        saleArr.push(fieldArr[i].fieldDataPropMap);
                                                        break;
                                                    }
                                                }

                                            }
                                        }
                                    }
                                }
                                saleObj[field] = saleArr;
                            }
                        }
                    }
                }
            }else{
                if(this.saleMap != null){
                    for(let field in this.saleMap){
                        for(let form in this.saleForm){
                            if(field === form){
                                let fieldArr = this.saleMap[field];
                                let formArr = this.saleForm[field];
                                let saleArr = [];
                                if(fieldArr != null && fieldArr.length > 0){
                                    for(let i = 0; i < fieldArr.length;i++){
                                        if(formArr != null && formArr.length > 0){
                                            for(let j = 0; j < formArr.length;j++){
                                                if(field === "color"){
                                                    if(formArr[j] === fieldArr[i].fieldDataPropMap.color.value){
                                                        saleArr.push(fieldArr[i].fieldDataPropMap);
                                                        break;
                                                    }
                                                }else{
                                                    if(formArr[j] === fieldArr[i].fieldDataPropMap.name.value){
                                                        saleArr.push(fieldArr[i].fieldDataPropMap);
                                                        break;
                                                    }
                                                }

                                            }
                                        }
                                    }
                                }
                                saleObj[field] = saleArr;
                            }
                        }
                    }
                }
            }
            this.saleObj = saleObj;
        },
    }
}
